import api from "./api";

// --- Inventory Items ---
export async function getInventoryItems(restaurantId) {
  const res = await api.get("/inventory/items", { params: { restaurantId } });
  return res.data;
}

export async function createInventoryItem(restaurantId, data) {
  const res = await api.post("/inventory/items", { ...data, restaurantId });
  return res.data;
}

export async function updateInventoryItem(restaurantId, itemId, data) {
  const res = await api.put(`/inventory/items/${itemId}`, {
    ...data,
    restaurantId,
  });
  return res.data;
}

export async function deleteInventoryItem(restaurantId, itemId) {
  const res = await api.delete(`/inventory/items/${itemId}`, {
    params: { restaurantId },
  });
  return res.data;
}

// --- Main Store ---
export async function getMainStoreData(restaurantId) {
  const res = await api.get("/inventory/main-store", {
    params: { restaurantId },
  });
  return res.data;
}

export async function getMainStoreSuppliers(restaurantId) {
  const res = await api.get("/inventory/main-store/suppliers", {
    params: { restaurantId },
  });
  return res.data;
}

// --- Stock Movements ---
export async function getStockMovements(restaurantId) {
  const res = await api.get("/inventory/movements", {
    params: { restaurantId },
  });
  return res.data;
}

export async function createStockMovement(restaurantId, data) {
  const res = await api.post("/inventory/movements", { ...data, restaurantId });
  return res.data;
}

// --- Opening Stock ---
export async function getOpeningStock(restaurantId, storeId) {
  const params = { restaurantId, storeId };
  const res = await api.get("/inventory/opening-stock", { params });
  return res.data;
}

export async function createOpeningStock(restaurantId, data) {
  const res = await api.post("/inventory/opening-stock", {
    restaurantId,
    ...data,
  });
  return res.data;
}

export async function updateOpeningStock(restaurantId, stockId, data) {
  const res = await api.put(
    `/inventory/opening-stock/${restaurantId}/${stockId}`,
    data
  );
  return res.data;
}

export async function deleteOpeningStock(restaurantId, stockId) {
  const res = await api.delete(
    `/inventory/opening-stock/${restaurantId}/${stockId}`
  );
  return res.data;
}

// --- Suppliers ---
export async function getSuppliers(restaurantId) {
  const res = await api.get("/inventory/suppliers", {
    params: { restaurantId },
  });
  return res.data;
}

export async function createSupplier(restaurantId, data) {
  const res = await api.post("/inventory/suppliers", {
    ...data,
    restaurantId,
  });
  return res.data;
}

export async function updateSupplier(restaurantId, supplierId, data) {
  const res = await api.put(
    `/inventory/suppliers/${restaurantId}/${supplierId}`,
    data
  );
  return res.data;
}

export async function deleteSupplier(restaurantId, supplierId) {
  const res = await api.delete(
    `/inventory/suppliers/${restaurantId}/${supplierId}`
  );
  return res.data;
}

// --- Analytics & Alerts ---
export async function checkLowStockAlerts(restaurantId) {
  const res = await api.get("/inventory/alerts/low-stock", {
    params: { restaurantId },
  });
  return res.data;
}

export async function getAutoReorderRecommendations(restaurantId) {
  const res = await api.get("/inventory/analytics/auto-reorder", {
    params: { restaurantId },
  });
  return res.data;
}

// --- Waste Inventory ---
export async function getWasteItems(restaurantId) {
  const res = await api.get("/inventory/waste", {
    params: { restaurantId },
  });
  return res.data;
}

export async function createWasteItem(restaurantId, data) {
  const res = await api.post("/inventory/waste", {
    ...data,
    restaurantId,
  });
  return res.data;
}

export async function updateWasteItem(restaurantId, itemId, data) {
  const res = await api.put(`/inventory/waste/${restaurantId}/${itemId}`, data);
  return res.data;
}

export async function deleteWasteItem(restaurantId, itemId) {
  const res = await api.delete(`/inventory/waste/${restaurantId}/${itemId}`);
  return res.data;
}
